module.exports = __webpack_public_path__ + "static/img/khfw22_2.68c749a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw22_2.png
// module id = 3uR0
// module chunks = 3